// extracted by mini-css-extract-plugin
export var blockTitle = "main-module--block-title--68e29";
export var btnBlock = "main-module--btn-block--0cc7c";
export var containerMax = "main-module--container-max--81f45";
export var mainBtn = "main-module--main-btn--46c78";
export var sec = "main-module--sec--4566d";